import {
  UPDATE_MATCH,
  UPDATE_MATCH_GAME_IDS,
  MATCH_LOADING_IN_PROGRESS,
  MATCH_LOADING_COMPLETED,
  MATCH_LOADING_ERROR,
  MATCH_UPDATING_IN_PROGRESS,
  MATCH_UPDATING_COMPLETED,
  MATCH_UPDATING_ERROR,
} from "../actions";
import { match_detail_url } from "../utils/constants";
import _ from "lodash";
import axios from "axios";

var gamesTemplate_PA3 = [
  {
    sequence: 1,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 2,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 3,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
];

var gamesTemplate_BO5 = [
  {
    sequence: 1,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 2,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 3,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 4,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
  {
    sequence: 5,
    gameAoe2Id: "",
    gameWinner: "",
    gameCivA: "generic_civ",
    gameCivB: "generic_civ",
    map: "cm_generic",
    gameRec: "",
  },
];

const mergeGames = (games, template, fields) => {
  var toRet = [...template];

  for (const game of toRet) {
    for (const temp of games) {
      if (game.sequence === temp.sequence) {
        for (const field of fields) {
          game[field] = temp[field];
        }
        break;
      }
    }
  }
  return toRet;
};

const compareGames = (games1, games2) => {
  const fields = [
    "gameAoe2Id",
    "gameCivA",
    "gameCivB",
    "sequence",
    "gameRec",
    "gameWinner",
    "map",
  ];

  if (games1.length !== games2.length) {
    return false;
  }

  var index = 0;
  for (var i = 0; index < games1.length; index++) {
    const game1 = games1[i];
    const game2 = games2[i];
    for (const field of fields) {
      if (!(game1[field] === game2[field])) {
        return false;
      }
    }
  }
  return true;
};

const doPut = async (matchInfo) => {
  var access_token = localStorage.getItem("access_token");
  if (!access_token) {
    console.error(`match_reducer :: doPut -> it's necessary be logged`);
    return false;
  }
  const config = {
    headers: { Authorization: `Bearer ${access_token}` },
  };

  var data = { ...matchInfo };
  console.log("data:");
  console.log(data);
  const response = await axios.put(
    `${match_detail_url.replace(":matchId", matchInfo.matchId)}`,
    data,
    config
  );

  console.log(response.status);
};

const updateMatch = (match) => {
  console.log("match_reducer :: Updating match");
  console.log(match);
  const maxLength = match.match.gamesFormat === "PA3" ? 3 : 5;
  console.log(maxLength);
  console.log(match.match.games.length);

  var gamesTemplate =
    match.match.gamesFormat === "PA3" ? gamesTemplate_PA3 : gamesTemplate_BO5;

  var gamesInfo = [...gamesTemplate];
  if (match.match.games && match.match.games.length === maxLength) {
    console.log(`match_reducer :: updateMatch - punto 1`);
    gamesInfo = mergeGames(match.match.games, gamesInfo, [
      "gameWinner",
      "gameCivA",
      "gameCivB",
      "map",
      "gameRec",
    ]);
    console.log(match.match.games);
    console.log(gamesInfo);
  }
  if (match.gameIds && match.gameIds.length === maxLength) {
    console.log(`match_reducer :: updateMatch - punto 2`);
    gamesInfo = mergeGames(match.gameIds, gamesTemplate, ["gameAoe2Id"]);
    console.log(match.match.games);
    console.log(gamesInfo);
  }

  let matchInfo = { ...match.match, games: gamesInfo };
  console.log(matchInfo);

  doPut(matchInfo);
};

const match_reducer = (state, action) => {
  if (action.type === MATCH_LOADING_IN_PROGRESS) {
    return { ...state, loading: true, error: false };
  }
  if (action.type === MATCH_LOADING_COMPLETED) {
    return {
      ...state,
      loading: false,
      error: false,
      match: { ...action.payload.match },
      gameIds: [...action.payload.gameIds],
    };
  }
  if (action.type === MATCH_LOADING_ERROR) {
    return { ...state, loading: false, error: true };
  }
  if (action.type === MATCH_UPDATING_IN_PROGRESS) {
    return {
      ...state,
      updating: true,
      updatingError: false,
      match: { ...action.payload.match },
    };
  }
  if (action.type === MATCH_UPDATING_ERROR) {
    return { ...state, updating: false, updatingError: true };
  }
  if (action.type === MATCH_UPDATING_COMPLETED) {
    return {
      ...state,
      updating: false,
      updatingError: false,
      match: { ...action.payload },
    };
  }
  if (action.type === UPDATE_MATCH) {
    console.log("UPDATE_MATCH :: lets compare ");
    if (
      !_.isEqual(state.match, action.payload.match) ||
      !compareGames(state.match.games, action.payload.match.games)
    ) {
      console.log("# reducer :: UPDATE!!!! info general de la partida."); // DEBUG
      console.log(action.payload.match); // DEBUG

      updateMatch({ ...state, match: { ...action.payload.match } });
      return { ...state, match: { ...action.payload.match } };
    } else {
      console.log("# reducer :: NO-UPDATE"); // DEBUG
      console.log(action.payload.match); // DEBUG
    }
    return { ...state };
  }
  if (action.type === UPDATE_MATCH_GAME_IDS) {
    /* 
      This logic it's a bit tricky. We have to make an entire copy of each object and array:
      https://beta.reactjs.org/learn/updating-arrays-in-state 
      TODO: check Immer to do it easier
      */
    /* let tempGames = state.gameIds.map((game) => {
      if (game.gameId === action.payload.game.gameId) {
        return { ...action.payload.game };
      }
      return game;
    }); */

    if (_.isEqual(state.gameIds, action.payload.gameIds)) {
      //console.log("# reducer :: NO-UPDATE! info de 'games' de la partida"); // DEBUG
    } else {
      //console.log("# reducer :: UPDATE!!!! info de 'games' de la partida."); // DEBUG
      //console.log(action.payload.gameIds); // DEBUG

      updateMatch({ ...state, gameIds: action.payload.gameIds });

      return { ...state, games: action.payload.gameIds };
    }
  }

  throw new Error(
    `Match Reducer :: No Matching "${action.type}" - action type`
  );
};

export default match_reducer;
